import React, { useEffect, useState } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Comments from './components/Comments/Comments';
import Services from './components/Services/Services';
import ServiceComparison from './components/ServiceComparison/ServiceComparison';
import Pricing from './components/Pricing/Pricing';
import AdditionalServices from './components/AdditionalServices/AdditionalServices';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import AdminComplete from './components/Admin/AdminComplete';
import { useGoogleTag } from './hooks/useAdminData';
import './App.scss';
import {
  googleAdsConversionInlineScript,
  googleAdsConversionScriptSrc,
} from './data/analyticsScripts';

function App() {
  const [showAdmin, setShowAdmin] = useState(false);
  const googleTag = useGoogleTag();

  useEffect(() => {
    // Check if admin route is active
    const checkAdminRoute = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(window.location.search);
      setShowAdmin(hash === '#admin' || params.get('admin') === 'true');
    };

    checkAdminRoute();
    window.addEventListener('hashchange', checkAdminRoute);
    window.addEventListener('popstate', checkAdminRoute);

    return () => {
      window.removeEventListener('hashchange', checkAdminRoute);
      window.removeEventListener('popstate', checkAdminRoute);
    };
  }, []);

  useEffect(() => {
    // Don't load Google Tag in admin panel
    if (showAdmin) {
      return;
    }

    // Use admin data if available, otherwise use default
    const scriptSrc = googleTag?.scriptSrc || googleAdsConversionScriptSrc;
    const inlineScriptContent = googleTag?.inlineScript || googleAdsConversionInlineScript;

    if (!scriptSrc || !inlineScriptContent) {
      return;
    }

    const scriptId = 'google-ads-conversion-script';
    const inlineScriptId = 'google-ads-conversion-inline';

    // Remove existing scripts if they exist
    const existingScript = document.getElementById(scriptId);
    const existingInlineScript = document.getElementById(inlineScriptId);
    if (existingScript) existingScript.remove();
    if (existingInlineScript) existingInlineScript.remove();

    // Add new script
    if (scriptSrc) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = scriptSrc;
      document.head.appendChild(script);
    }

    // Add inline script
    if (inlineScriptContent) {
      const inlineScript = document.createElement('script');
      inlineScript.id = inlineScriptId;
      inlineScript.innerHTML = inlineScriptContent;
      document.head.appendChild(inlineScript);
    }
  }, [googleTag, showAdmin]);

  // Show admin panel if route is active
  if (showAdmin) {
    return (
      <div className="App">
        <AdminComplete />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Comments />
        <Services />
        <ServiceComparison />
        <Pricing />
        <AdditionalServices />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;